module.exports = __webpack_public_path__ + "img/img14.bc7e2f80.png";